import Select from 'peach/components/Select/Select'
import { getName } from 'peach/helpers'
import { useParams } from 'peach/router'

import { useInternalListCasesByBorrower } from 'core/types'

const PersonCaseSelect = (props) => {
  const { companyId, personId } = useParams<{
    companyId?: string
    personId?: string
  }>()

  const { data: cases, isLoading } = useInternalListCasesByBorrower({
    companyId,
    personId,
  })

  const options = _.map(cases, ($case) => ({
    value: $case.id,
    label: getName($case),
  }))

  return <Select loading={isLoading} {...props} options={options} />
}

export default PersonCaseSelect
